import Api from "../../helpers/api";
import Locations from "../../helpers/locations";
import Constants from "./DLConstants";

export const getImagineCenterAddress = (center, display_name, id) => {
  return function(dispatch) {
    const param ={
      center,
      display_name
    }
    const location = `${Locations?.imagineCenterAddress}${id}`

    const successCall = (response) => {
      console.log(response, "<<<<getImagineCenterAddress");
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_ADD_SUCCESS,
        payload: response,
      });
    };

    const errorCall = (errorResponse) => {
      console.log(errorResponse, "getImagineCenterAddress---error");
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_ADD_FAILED,
        payload: errorResponse,
      });
    };
    Api.doGet(Locations.imagineCenterAddress, location, param, successCall, errorCall);
  };
};

export const getImagineCenterData = (name_or_code) => {
  return function(dispatch) {
    const param = {
      imaging: 'true',
      name_or_code
    }
    const successCall = (response) => {
      // console.log(payload.results, "getImagineCenterAddress---error");
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_DATA_SUCCESS,
        payload: response?.results,
      });
    };

    const errorCall = (errorResponse) => {
      console.log(errorResponse, "getImagineCenterAddress---error");
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_DATA_FAILED,
        payload: errorResponse,
      });
    };
    Api.doGet(Locations.imagineCenterData, param, successCall, errorCall);
  };
};

export const getImagingCenter = (slug) => {
  return function(dispatch) {
    const param = {
        slug
    }  

    const successCall = (response) => {
  
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_PACK_DATA_SLUG_SUCCESS,
        payload: response,
      });
    };

    const errorCall = (errorResponse) => {
    
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_PACK_DATA_FAIL,
        payload: errorResponse,
      });
    };
    Api.doGet(Locations?.imagineCenterAddress, param, successCall, errorCall);
  };
};

export const getRelatedSubcenterPackage = (id) => {

  return function(dispatch) {
    const param ={
    }
    const location = `${Locations?.imagingCheapPackage}${id}`

    const successCall = (response) => {
  
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_PACK_DATA_ID_SUCCESS,
        payload: response,
      });
    };

    const errorCall = (errorResponse) => {
    
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_PACK_DATA_FAIL,
        payload: errorResponse,
      });
    };
    Api.doGet(location, param, successCall, errorCall);
  };
};


export const getSubCenterFromId = (id) => {
  return function(dispatch) {
    const param = {
      center:id
    }
    // const location = `${Locations?.imagineCenterAddress}${id}`

    const successCall = (response) => {
      dispatch({
        type: Constants.ACTIONS.GET_SUB_CENTER,
        payload: response,
      });
    };

    const errorCall = (errorResponse) => {
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_ADD_FAILED,
        payload: errorResponse,
      });
    };
    Api.doGet(Locations?.imagineCenterAddress, param, successCall, errorCall);
  };
};

export const getNearbyCities = (city) => {
  console.log(city, "cityname<<<")
  return function(dispatch) {
    const param = {
      cityname:city
    }

    const successCall = (response) => {
      dispatch({
        type: Constants.ACTIONS.GET_NEARBY_CITIES,
        payload: response,
      });
    };

    const errorCall = (errorResponse) => {
      dispatch({
        type: Constants.ACTIONS.GET_IMAGINE_ADD_FAILED,
        payload: errorResponse,
      });
    };
    Api.doGet(Locations?.imagineCenterAddress, param, successCall, errorCall);
  };
};

export const postDldetailFormData = (body) => {
  console.log(body, "body")
  return function(dispatch) {
    const successCall = (response) => {
      console.log(response, "<<<<<<< ---");
      // dispatch({
      //     type: Constants.ACTIONS.POST_QUESTIONS_DATA_SUCCESS,
      //     payload: response
      // });
    };

    const errorCall = (errorResponse) => {
      console.log(errorResponse, "<<<<<<---<");
      // dispatch({
      //     type: Constants.ACTIONS.POST_QUESTIONS_DATA_FAILED,
      //     payload: errorResponse
      // });
    };

    Api.doPost(Locations.callBackLead, body, successCall, errorCall,false,{});
  };
};

export default {
  getImagineCenterAddress,
  getImagineCenterData,
  getRelatedSubcenterPackage,
  getImagingCenter,
  getSubCenterFromId,
  getNearbyCities,
  postDldetailFormData
};
